import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom"; // To get customerId from the URL
import { ADMIN_API_URL } from "../../constants";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

const AllCustomerLoans = () => {
    const { mobile } = useParams(); // Extract customerId from the URL
    const [loans, setLoans] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchLoansByMobile = async () => {
            try {
                // 1. Fetch customer using mobile number
                const customerRes = await fetch(`${ADMIN_API_URL}customers/${mobile}`);
                const customerData = await customerRes.json();

                const customerId = customerData.data?.customerId;
                if (!customerId) {
                    throw new Error("Customer not found for mobile " + mobile);
                }

                // 2. Fetch loans for that customer
                const loanRes = await fetch(`${ADMIN_API_URL}loans/customer/${customerId}`);
                const loanData = await loanRes.json();

                setLoans(loanData.data || []);
            } catch (err) {
                setError(err.message || "Failed to load data");
            } finally {
                setLoading(false);
            }
        };

        fetchLoansByMobile();
    }, [mobile]);

    if (loading) return <p>Loading...</p>;
    if (error) return <p>{error}</p>;

    return (
        <>
            <Header />
            <div id="wrapper">
                <div class="normalheader ">
                    <div class="hpanel">
                        <div class="panel-body">
                            <a class="small-header-action" href="">
                                <div class="clip-header">
                                    <i class="fa fa-arrow-up"></i>
                                </div>
                            </a>
                            <h2 class="font-light m-b-xs">
                                Loans for Customer
                            </h2>
                        </div>
                    </div>
                </div>
                <div class="content">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="hpanel">
                                <div class="panel-body">
                                    <div class="table-responsive">
                                        <table cellPadding="1" cellSpacing="1" className="table">
                                            <thead>
                                                <tr>
                                                    <th>Product Type</th>
                                                    <th>Loan Amount</th>
                                                    <th>Status</th>
                                                    <th>Created At</th>
                                                    <th>Updated At</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {loans.length > 0 ? (
                                                    loans.map((loan) => (
                                                        <tr key={loan.id}>
                                                            <td>{loan.productType}</td>
                                                            <td>₹{loan.loanAmount}</td>
                                                            <td>{loan.status}</td>
                                                            <td>{new Date(loan.createdAt).toLocaleDateString()}</td>
                                                            <td>{new Date(loan.updatedAt).toLocaleDateString()}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="5">No loans found</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </>
    );
};

export default AllCustomerLoans;
